// Erbity Website Mock Data

export const companyMetrics = {
  primary: [
    { value: '100+', label: 'Placements Made', sublabel: 'Engineers placed across semiconductor & tech' },
    { value: '10+', label: 'Active Clients', sublabel: 'Fortune 500 & fast-growing scale-ups' },
    { value: 'Semi + VLSI', label: 'Domain Expertise', sublabel: 'Strong semiconductor & VLSI depth' },
    { value: '95%', label: 'Retention Rate', sublabel: 'Engineers stay and grow with clients' },
  ],
  secondary: [
    { value: '48\u201372 hrs', label: 'Shortlist Turnaround' },
    { value: '40%', label: 'Faster Time-to-Hire' },
    { value: '100+', label: 'Engineers Placed' },
    { value: '6+', label: 'Industry Sectors' },
    { value: '3nm', label: 'Advanced Node Capability' },
  ],
};

export const services = [
  {
    id: 'permanent-placement',
    title: 'Permanent Placement',
    tagline: 'Direct hire, built to last',
    description:
      'Full-time engineering placements \u2014 curated, domain-vetted and ready to contribute from day one. We source, screen and shortlist so you only meet the top 5%.',
    features: [
      'RTL / DV Engineers',
      'Physical Design & Layout',
      'Analog / Mixed-Signal',
      'Embedded & Firmware',
      'FPGA Specialists',
    ],
    meta: 'Typical time-to-offer: 2\u20133 weeks',
  },
  {
    id: 'project-staffing',
    title: 'Project Staffing Support',
    tagline: 'Scale on-demand',
    description:
      'On-demand contract engineers deployed on short-to-medium term programs. Scale your team for a tape-out sprint or critical milestone without permanent headcount.',
    features: [
      'Flexible Duration',
      'Immediate Start',
      'Multi-disciplinary Pods',
      'Onsite / Hybrid / Remote',
      'No Long-term Obligation',
    ],
    meta: 'Start in as little as 1 week',
  },
  {
    id: 'rpo',
    title: 'RPO Solution',
    tagline: 'End-to-end recruitment engine',
    description:
      'Outsource your entire semiconductor hiring pipeline \u2014 job profiling, sourcing, screening, interview coordination, offer management and onboarding support.',
    features: [
      'End-to-End TA Function',
      'Employer Branding',
      'Reporting & Analytics',
      'SLA-Driven Delivery',
      'High-Volume Scaling',
    ],
    meta: 'Best for rapid scaling programs',
  },
];

export const industries = [
  {
    id: 'semiconductor',
    name: 'Semiconductor & Chip Design',
    blurb:
      'From advanced-node ASIC programs to memory and SoC design \u2014 we place engineers who ship silicon.',
    tags: ['VLSI', 'SoC', 'ASIC', 'Memory', '3nm\u201328nm'],
    image: '/industries/semiconductor.jpg',
  },
  {
    id: 'automotive',
    name: 'Automotive',
    blurb:
      'ADAS, infotainment, powertrain and functional safety \u2014 talent aligned with ISO 26262 workflows.',
    tags: ['ADAS', 'Infotainment', 'Powertrain', 'LiDAR / Radar'],
    image: '/industries/automotive.jpg',
  },
  {
    id: 'aerospace',
    name: 'Aerospace & Defense',
    blurb:
      'Mission-critical engineering talent for radar, avionics and satellite communication systems.',
    tags: ['Avionics', 'Radar', 'SatComm', 'Mission-Critical'],
    image: '/industries/aerospace.jpg',
  },
  {
    id: 'industrial',
    name: 'Industrial Engineering',
    blurb:
      'Automation, robotics and Industry 4.0 talent \u2014 from control systems to edge intelligence.',
    tags: ['Automation', 'Robotics', 'Edge AI', 'Industrial IoT'],
    image: '/industries/industrial.jpg',
  },
  {
    id: 'consumer',
    name: 'Consumer Electronics',
    blurb:
      'Wearables, mobile SoCs, smart-home and AR/VR platforms \u2014 high-volume design talent.',
    tags: ['Mobile', 'Wearables', 'Smart Home', 'AR / VR'],
    image: '/industries/consumer.jpg',
  },
  {
    id: 'telecom',
    name: 'Telecom & Connectivity',
    blurb:
      'Baseband, RF, 5G and networking talent \u2014 from PHY layer to protocol stacks.',
    tags: ['5G', 'RF', 'Baseband', 'Networking'],
    image: '/industries/telecom.jpg',
  },
];

export const expertiseAreas = [
  {
    title: 'Semiconductor Design',
    description:
      'Frontend RTL design, functional verification, DFT, physical design, analog and mixed-signal \u2014 full-stack silicon capability.',
    points: ['RTL Coding & IP Integration', 'UVM / SystemVerilog Verification', 'STA & Timing Closure', 'DFT / ATPG'],
  },
  {
    title: 'VLSI',
    description:
      'End-to-end VLSI talent \u2014 from micro-architecture through GDSII sign-off \u2014 across advanced nodes down to 3nm.',
    points: ['Floorplanning & CTS', 'Placement & Routing', 'Sign-off (DRC/LVS/ERC)', 'Parasitic Extraction'],
  },
  {
    title: 'Embedded Engineering',
    description:
      'Firmware, device drivers, RTOS integration, platform software and IoT connectivity \u2014 the software layer that brings silicon to life.',
    points: ['Firmware & Bare-metal', 'RTOS (FreeRTOS, Zephyr)', 'Device Drivers & BSPs', 'IoT & Connectivity Stacks'],
  },
];

export const capabilities = [
  'RTL / Logic Design Engineers',
  'Functional Verification (UVM / SV)',
  'DFT & ATPG Engineers',
  'Physical Design Engineers',
  'Analog & Mixed-Signal Designers',
  'Layout / Custom IC Engineers',
  'FPGA Engineers',
  'Embedded SW / Firmware',
  'Post-Silicon Validation',
  'STA / Timing Engineers',
  'Power Integrity Specialists',
  'Silicon Bring-up Engineers',
];

export const whyErbity = [
  {
    title: 'Semiconductor-Only Focus',
    body: 'We recruit exclusively in semiconductors and advanced engineering \u2014 no generalist IT recruiters. Every role is vetted by engineers who have done the job.',
  },
  {
    title: 'Fast Time-to-Fill',
    body: 'Active talent pipeline across RTL, verification, DFT, PD, analog and embedded. Typical shortlist in 48\u201372 hours.',
  },
  {
    title: 'Pre-Vetted Talent',
    body: 'Multi-stage technical screening \u2014 domain-knowledge tests and live problem-solving sessions \u2014 before any CV reaches you.',
  },
  {
    title: 'Deep Talent Networks',
    body: 'Direct access to Bengaluru, Hyderabad, Pune and Chennai \u2014 where the majority of India\u2019s chip-design talent works and lives.',
  },
  {
    title: 'Retention Support',
    body: 'We stay engaged after placement \u2014 tracking performance and satisfaction so your hiring investment sticks.',
  },
  {
    title: 'Confidential & Discreet',
    body: 'NDAs by default. Confidential search for sensitive roles. Your competitive intelligence stays protected end-to-end.',
  },
];

export const process = [
  { step: '01', title: 'Discovery', body: 'Deep-dive into role scope, technology stack, team culture and success criteria.', image: '/process/discovery.jpg' },
  { step: '02', title: 'Sourcing', body: 'Targeted outreach across our vetted semiconductor network \u2014 both active and passive candidates.', image: '/process/sourcing.jpg' },
  { step: '03', title: 'Screening', body: 'Multi-stage technical + domain screening by our in-house engineers before shortlist.', image: '/process/screening.jpg' },
  { step: '04', title: 'Interview', body: 'We coordinate loops, prep candidates and give you signal-rich debriefs after each round.', image: '/process/interview.jpg' },
  { step: '05', title: 'Offer & Onboard', body: 'Offer negotiation, resignation support and 90-day check-ins to protect your hire.', image: '/process/offer.jpg' },
];

export const testimonials = [
  {
    quote:
      'Erbity delivered a shortlist of five RTL engineers in 72 hours \u2014 every one of them was interview-ready. We hired three.',
    name: 'VP of Engineering',
    role: 'US Fabless Semiconductor Company',
  },
  {
    quote:
      'They understand the difference between an engineer who knows Verilog and one who can close timing. That domain depth is rare.',
    name: 'Director, Silicon Design',
    role: 'Automotive Tier-1',
  },
  {
    quote:
      'Every candidate arrived pre-vetted by an engineer, not a keyword-matching recruiter. That saved us weeks of interviewing.',
    name: 'Head of Talent Acquisition',
    role: 'Semiconductor Design House',
  },
];

export const contactInfo = {
  companyName: 'Erbity Private Limited',
  email: 'sales@erbity.com',
  phone: '+91-83420-22020',
  hqLine: 'Bengaluru \u00b7 Hyderabad \u00b7 Pune \u00b7 Chennai',
  address: 'No.73, Nallurahalli, Whitefield, Bangalore South, Karnataka 560066, India',
};
